
import { get } from 'lodash'
import queryString from 'query-string'

export const parseAuthCode = props => {
  const query = queryString.parse(get(props, 'location.search'))

  return get(query, 'authorizationCode')
}
